var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThanksFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 84,
    viewBox: "0 0 91 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAC600",
    strokeWidth: 8.684,
    d: "M63.244 37.043L35.96 18.998 8.676 37.043l27.284 16.23 27.284-16.23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCF9",
    d: "M17.141 32.302H55.87V59.91H17.141z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.684,
    d: "M12.8 27.96H60.21v36.291H12.8v-36.29z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFCF9",
    stroke: "#FAC600",
    strokeWidth: 8.684,
    d: "M4.342 43.691v35.71h47.147c9.059 0 16.402-7.344 16.402-16.403V43.691L36.117 60.717 4.342 43.691z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#BBD557",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10.42,
    d: "M49.698 16.21l11.075 12.48L85.632 6",
    style: {
      mixBlendMode: "multiply"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThanksFeedback);
export default __webpack_public_path__ + "static/media/thanks-feedback.43d2f1a25cfc65f82fc9bb5a6f8a22b7.svg";
export { ForwardRef as ReactComponent };